var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        key: _vm.resetTab,
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u(
          [
            _vm.$helpers.hasSomePermission(["view_pending_receipt"])
              ? {
                  key: "main",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { disabled: !_vm.count, outlined: "" },
                          on: { click: _vm.getList },
                        },
                        [
                          _c("v-img", {
                            attrs: { contain: "", src: _vm.iconUpdateSrc },
                          }),
                        ],
                        1
                      ),
                      _c("VMainColumnRecordVisualization", {
                        attrs: {
                          headers: _vm.headersAux,
                          pageSize: _vm.pageSize,
                          object: "purchases-pending",
                        },
                        on: {
                          "update:headers": function ($event) {
                            _vm.headersAux = $event
                          },
                          "update:pageSize": function ($event) {
                            _vm.pageSize = $event
                          },
                          "update:page-size": function ($event) {
                            _vm.pageSize = $event
                          },
                        },
                      }),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-click": "",
                            "close-on-content-click": "",
                            "offset-y": "",
                            left: "",
                            "nudge-bottom": 10,
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-2",
                                            attrs: { outlined: "" },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("mdi-plus-box "),
                                        ]),
                                        _vm._v("Opciones"),
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "18", right: "" } },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3671956459
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: {
                                    disabled: !_vm.count,
                                    ripple: false,
                                  },
                                  on: { click: _vm.createDownloadList },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-1 grey-500--text" },
                                    [_vm._v("Descargar listado")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-query-builder", {
                        staticClass: "ml-2",
                        attrs: {
                          "query-map": _vm.filters,
                          model: "purchases",
                          active: _vm.activeFilter,
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.activeFilter = $event
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.$helpers.hasSomePermission(["view_pending_receipt"])
              ? {
                  key: "custom-tab",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        {
                          staticClass: "mt-14 ml-n6 mr-5",
                          style: `postion: absolute; border-bottom: 1px solid var(--${
                            _vm.$vuetify.theme.dark ? "dark" : "light"
                          }-grey-50)`,
                          attrs: { "no-gutters": "", align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 background",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-tabs",
                                {
                                  staticClass: "background pa-0 tab-rec",
                                  attrs: { height: 35 },
                                  model: {
                                    value: _vm.filter,
                                    callback: function ($$v) {
                                      _vm.filter = $$v
                                    },
                                    expression: "filter",
                                  },
                                },
                                _vm._l(_vm.currentStatus, function (status, i) {
                                  return _c(
                                    "v-tab",
                                    { key: i, attrs: { ripple: false } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-" + _vm._s(status.icon))]
                                      ),
                                      _vm._v(_vm._s(status.title) + " "),
                                      status.title === "Todas"
                                        ? void 0
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-25", attrs: { cols: "12" } },
        [
          _c("purchase-list", {
            attrs: {
              selectedDocuments: _vm.selectedDocuments,
              headerList: _vm.headerList,
              pageSize: _vm.pageSize,
            },
            on: {
              activeBtnFilter: function ($event) {
                _vm.activeFilter = true
              },
              "update:selectedDocuments": function ($event) {
                _vm.selectedDocuments = $event
              },
              "update:selected-documents": function ($event) {
                _vm.selectedDocuments = $event
              },
              getList: _vm.getList,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Descarga de documentos pendientes")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogExport = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text body-1 font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "Selecciona el formato de los archivos:"
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ml-n1",
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(_vm.fileFormat, function (file) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: file,
                                          staticClass: "pa-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0",
                                            attrs: {
                                              "input-value":
                                                _vm.types.includes(file) ||
                                                false,
                                              column: "",
                                              label: file,
                                              disabled:
                                                ["XLSX", "CSV"].includes(
                                                  file
                                                ) && _vm.count >= 1000000,
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getFileFormat(file)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass:
                        "inf-alert-blue green-500--text rounded-md mt-2",
                      attrs: { height: 58, dense: "", text: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 my-1" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "green-500", size: "22" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "caption",
                                staticStyle: { "line-height": "14px" },
                              },
                              [
                                _vm._v("Esta acción "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("podría tardar varios minutos")]
                                ),
                                _vm._v(" en completarse. Recibirás un "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      " correo electrónico con el enlace de descarga."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogExport = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        ripple: false,
                        disabled: !_vm.types.length,
                      },
                      on: { click: _vm.createExport },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }